/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTaxCategoryRequest } from '../../models/create-tax-category-request';
import { TaxCategory } from '../../models/tax-category';

export interface TaxCategoriesPost$Params {
  'Active-Tenant-Identifier': string;
      body: CreateTaxCategoryRequest
}

export function taxCategoriesPost(http: HttpClient, rootUrl: string, params: TaxCategoriesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategory>> {
  const rb = new RequestBuilder(rootUrl, taxCategoriesPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TaxCategory>;
    })
  );
}

taxCategoriesPost.PATH = '/tax-categories';
